module.exports = __webpack_public_path__ + "img/336.aec2183d.jpg";